module.exports = __webpack_public_path__ + "static/logo-redfinnow-658d10f8248bd8c3e014bede8f2ba977.png";